import libPhoneNumber from 'google-libphonenumber'
import store from '@/store'

function validatePhoneNumber(n) {
  const phoneUtil = libPhoneNumber.PhoneNumberUtil.getInstance()
  try {
    const number = phoneUtil.parse(n, store.getters.currentLanguage.regionInfo.twoLetterISORegionName)
    return phoneUtil.isValidNumber(number)
  } catch(e) {
    return false
  }
}

function validateEmail(email) {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)
}

export default { validatePhoneNumber, validateEmail }
